import { IImpregnation } from 'src/generated-types/impregnation'
import { useDelete, useGet, usePost, usePut } from './reactQuery'
import { queryClient } from 'src/query-client'
import { impregnationQueryKeys } from 'src/query-keys'

const baseUrl = (equipmentId: EntityId) => `equipment/${equipmentId}/impregnations`

export const impregnationEndPoints = {
  getImpregnations(equipmentId: EntityId) {
    return `${baseUrl(equipmentId)}`
  },
  createImpregnation(equipmentId: EntityId) {
    return `${baseUrl(equipmentId)}`
  },
  updateImpregnation(equipmentId: EntityId, impregnationId: EntityId) {
    return `${baseUrl(equipmentId)}/${impregnationId}`
  },
  deleteImpregnation(equipmentId: EntityId) {
    return `${baseUrl(equipmentId)}`
  },
}

export const invalidateImpregnationCache = {
  getImpregnations(equipmentId?: EntityId) {
    queryClient.invalidateQueries(impregnationQueryKeys.GET_IMPREGNATIONS(equipmentId))
  },
}

export const useGetImpregnations = (equipmentId: EntityId) =>
  useGet<Array<IImpregnation>>(impregnationEndPoints.getImpregnations(equipmentId))

export const useCreateImpregnation = (equipmentId: EntityId) =>
  usePost<IImpregnation, IImpregnation>(impregnationEndPoints.createImpregnation(equipmentId), {
    onSuccess: () => {
      invalidateImpregnationCache.getImpregnations(equipmentId)
    },
  })

export const useUpdatetImpregnation = (equipmentId: EntityId, impregnationId: EntityId) =>
  usePut<IImpregnation, IImpregnation>(impregnationEndPoints.updateImpregnation(equipmentId, impregnationId), {
    onSuccess: () => {
      invalidateImpregnationCache.getImpregnations(equipmentId)
    },
  })

export const useDeleteImpregnation = (equipmentId: EntityId) =>
  useDelete<IImpregnation>(impregnationEndPoints.deleteImpregnation(equipmentId), {
    onSuccess: () => {
      invalidateImpregnationCache.getImpregnations(equipmentId)
    },
  })
